import { makeStyles } from "@material-ui/core/styles";
import { rv } from "../../tokens";

// Shared input chrome matching the design tokens: 46px height, 1.5px #CFCFCF
// stroke, 10px radius, green focus ring, red error state.
export const useFieldStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(0.5),
  },
  label: {
    display: "block",
    fontSize: 11,
    fontWeight: 600,
    lineHeight: 1.4,
    textTransform: "uppercase",
    letterSpacing: ".04em",
    color: rv.muted,
    marginBottom: 7,
  },
  required: {
    color: rv.errorFg,
  },
  control: {
    "& .MuiOutlinedInput-root": {
      borderRadius: rv.radiusInput,
      background: "#fff",
      fontFamily: rv.fontSans,
    },
    // Force Poppins on both the text input and the select's value display so
    // they render identically (the select value otherwise falls back to a
    // different family).
    "& .MuiOutlinedInput-input": {
      padding: "13px 14px",
      fontSize: 14,
      color: rv.body,
      fontFamily: rv.fontSans,
    },
    "& .MuiSelect-select": {
      padding: "13px 40px 13px 14px",
      fontSize: 14,
      color: rv.body,
      fontFamily: rv.fontSans,
    },
    "& .MuiSelect-select:focus": { background: "transparent" },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: rv.inputStroke,
      borderWidth: 1.5,
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: rv.green500,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: rv.green,
      borderWidth: 1.5,
      boxShadow: "0 0 0 3px rgba(37,97,65,.12)",
    },
    "& .MuiOutlinedInput-root.Mui-error": { background: rv.errorBg2 },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: rv.errorFg,
    },
    "& .MuiSelect-icon": { color: rv.muted, right: 10 },
  },
  error: {
    display: "flex",
    alignItems: "center",
    gap: 5,
    color: rv.errorFg,
    fontSize: 11.5,
    fontWeight: 500,
    marginTop: 5,
  },
}));
